import { takeEvery, put, select, all } from 'redux-saga/effects';

import { tracking as trackingActions } from 'flux/actions';
import { property as propertySelectors } from 'flux/selectors';

export function* onPageview({ payload: { location } }) {
  const { pathname, search } = location;

  const propertyGAIds = yield select(propertySelectors.selectPropertyGoogleAnalytics);
  const isProfilingConsent = yield select(propertySelectors.selectIsProfilingConsent);
  if (propertyGAIds.length <= 0) return;

  // https://developers.google.com/analytics/devguides/collection/gtagjs/migration#track_pageviews
  // https://developers.google.com/analytics/devguides/collection/gtagjs/pages
  const trackPageView = (id) =>
    put(
      trackingActions.gtag('event', 'page_view', {
        send_to: id,
        page_path: `${pathname}${search}`,
      }),
    );

  if (propertyGAIds[0]) {
    yield trackPageView(propertyGAIds[0]);
  }

  // remove first GAId of shopfully beacuse its event already fired
  propertyGAIds.shift();
  if (isProfilingConsent) {
    yield all(propertyGAIds.map((id) => id && trackPageView(id)));
  }
}

export default function* () {
  yield takeEvery(trackingActions.types.GA_PAGEVIEW, onPageview);
}
